'use client';

import { useSearchParams } from 'next/navigation';
import { type ReactNode } from 'react';

type SelectedDrawProps = {
  openDrawComponent: ReactNode;
  selectedDrawComponent: ReactNode;
};

/**
 * Handles rendering of either the open draw or selected draw component based on URL search params.
 *
 * @param root0 The component props
 * @param root0.openDrawComponent The component to render when the draw is open
 * @param root0.selectedDrawComponent The component to render when the draw is closed
 * @returns The appropriate component based on the drawOpen search parameter
 */
export default function DrawHandler({ openDrawComponent, selectedDrawComponent }: SelectedDrawProps): ReactNode {
  const searchParams = useSearchParams();
  const isDrawOpen = searchParams.get('drawOpen')?.toLowerCase() === 'true';

  return (
    <section aria-label="Omgång" className={isDrawOpen ? 'lg:mb-28' : undefined}>
      {isDrawOpen ? openDrawComponent : selectedDrawComponent}
    </section>
  );
}
